import { ConstructionSiteAnalysisData } from "@dune/types";

interface ConstructionSiteInfoProps {
	data: ConstructionSiteAnalysisData;
}

export const ConstructionSiteInfo = ({ data }: ConstructionSiteInfoProps) => {
	return (
		<div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-4">
			<h4 className="text-sm font-medium text-blue-900 mb-2">
				Informations du chantier
			</h4>
			<div className="grid grid-cols-2 gap-4 text-xs">
				<div>
					<span className="font-medium">Coût de construction:</span>{" "}
					{data.constructionCost.toLocaleString("fr-FR")} €
				</div>
				<div>
					<span className="font-medium">Type d'opération:</span>{" "}
					{data.operationType}
				</div>
				<div>
					<span className="font-medium">Surface créée:</span> {data.createdArea}{" "}
					m²
				</div>
				<div>
					<span className="font-medium">Risque RGA:</span> {data.rgaRisk}
				</div>
				<div>
					<span className="font-medium">Atteinte structure:</span>{" "}
					{data.structuralDamage ? "Oui" : "Non"}
				</div>
				<div>
					<span className="font-medium">Reprise sous-œuvre:</span>{" "}
					{data.underpinning ? "Oui" : "Non"}
				</div>
			</div>
		</div>
	);
};
